import { render, staticRenderFns } from "./registrateProgress.vue?vue&type=template&id=3bc0b419&scoped=true"
import script from "./registrateProgress.vue?vue&type=script&lang=js"
export * from "./registrateProgress.vue?vue&type=script&lang=js"
import style0 from "./registrateProgress.vue?vue&type=style&index=0&id=3bc0b419&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc0b419",
  null
  
)

export default component.exports